module.exports = __webpack_public_path__ + "static/media/breedon.383bcd00.png";